/**
 * AlphaX Tuning Simulator - Data Logging & Export
 */

let isLoggingEnabled = false;
let isDevLoggingEnabled = false;
let datalogRows = [];
let lastLogRpm = 0;
let logTimeAccumulator = 0;

function toggleAutoLog(e) {
    // Only prevent default if we're clicking the button, let the checkbox handle itself natively.
    if (e && e.target && e.target.tagName !== 'INPUT') {
        e.preventDefault();
    }

    if (isLoggingEnabled && (!e || !e.shiftKey) && isDevLoggingEnabled) {
        // If they are in dev mode and just click normally, shut it off entirely.
        isLoggingEnabled = false;
        isDevLoggingEnabled = false;
        if (typeof appMode !== 'undefined' && appMode === 'garage') exportDatalog('Garage');
    } else if (isLoggingEnabled) {
        isLoggingEnabled = false;
        isDevLoggingEnabled = false;
        if (typeof appMode !== 'undefined' && appMode === 'garage') exportDatalog('Garage');
    } else {
        if (typeof appMode !== 'undefined' && appMode === 'garage' &&
            typeof isEngineRunning !== 'undefined' && !isEngineRunning) {
            return; // button is visually disabled; do nothing
        }
        isLoggingEnabled = true;
        datalogRows = [];
        lastLogRpm = 0;
        logTimeAccumulator = 0;
        if (e && e.shiftKey && window.devLoggingAllowed) isDevLoggingEnabled = true;
    }

    // Give the DOM a tiny bit to settle if it was a native click
    setTimeout(updateAutoLogUI, 10);
}

function updateAutoLogUI() {
    const btnDyno   = document.getElementById('btn-autolog-dyno');
    const btnGarage = document.getElementById('btn-log-garage');
    const chkDrag   = document.getElementById('chk-autolog-drag');
    const lblDrag   = document.querySelector('label[for="chk-autolog-drag"]');

    if (isDevLoggingEnabled) {
        if (btnDyno) {
            btnDyno.innerText = "[DEV] AUTO-LOG ON";
            btnDyno.className = "px-4 py-2 font-bold rounded transition-all text-xs border border-purple-500 bg-purple-700 hover:bg-purple-600 text-white shadow-[0_0_10px_rgba(168,85,247,0.5)]";
        }
        if (btnGarage) {
            btnGarage.innerText = "[DEV] LOG ON";
            btnGarage.className = "px-4 py-1.5 font-bold rounded transition-all text-xs border border-purple-500 bg-purple-700 hover:bg-purple-600 text-white shadow-[0_0_10px_rgba(168,85,247,0.5)]";
        }
        if (chkDrag) chkDrag.checked = true;
        if (lblDrag) {
            lblDrag.innerText = "[DEV] Auto-Log Passes";
            lblDrag.className = "text-xs font-bold cursor-pointer text-purple-400";
        }
    } else if (isLoggingEnabled) {
        if (btnDyno) {
            btnDyno.innerText = "AUTO-LOG ON";
            btnDyno.className = "px-4 py-2 font-bold rounded transition-all text-xs border border-green-500 bg-green-700 hover:bg-green-600 text-white shadow-[0_0_10px_rgba(34,197,94,0.5)]";
        }
        if (btnGarage) {
            btnGarage.innerText = "LOG ON";
            btnGarage.className = "px-4 py-1.5 font-bold rounded transition-all text-xs border border-green-500 bg-green-700 hover:bg-green-600 text-white shadow-[0_0_10px_rgba(34,197,94,0.5)]";
        }
        if (chkDrag) chkDrag.checked = true;
        if (lblDrag) {
            lblDrag.innerText = "Auto-Log Passes";
            lblDrag.className = "text-xs font-bold cursor-pointer text-green-400";
        }
    } else {
        if (btnDyno) {
            btnDyno.innerText = "AUTO-LOG OFF";
            btnDyno.className = "px-4 py-2 bg-gray-700 hover:bg-gray-600 text-gray-300 font-bold rounded transition-all text-xs border border-gray-600";
        }
        if (btnGarage) {
            btnGarage.innerText = "LOG OFF";
            btnGarage.className = "px-4 py-1.5 bg-gray-700 hover:bg-gray-600 text-gray-300 font-bold rounded transition-all text-xs border border-gray-600";
        }
        if (chkDrag) chkDrag.checked = false;
        if (lblDrag) {
            lblDrag.innerText = "Auto-Log Passes";
            lblDrag.className = "text-xs text-gray-300 font-bold cursor-pointer";
        }
    }
}

function exportDatalog(prefix) {
    if (datalogRows.length === 0) return;

    const iatUnit = (typeof tempUnitF !== 'undefined' && !tempUnitF) ? '°C' : '°F';
    const ectUnit = iatUnit;
    let headers = ["Time (s)", "RPM", "MAP (kPa)", "Boost (psi)", "TPS (%)", `IAT (${iatUnit})`, "Target AFR", "Actual AFR", "Ign Timing (deg)", "Inj PW (ms)", "VVT Intake (deg)", "VVT Exhaust (deg)", "VVL State", "WG Duty (%)", "Knock Count", "Current VE (%)", "Actual Torque (lb-ft)", `ECT (${ectUnit})`, "N2O_Active"];
    
    if (isDevLoggingEnabled) {
        headers.push("Turbo Speed (RPM)", "Turbo Eff (%)", "Engine CFM", "Ideal Base Torque", "Ideal Base VE", "Ideal Target AFR", "Ideal MBT (deg)", "Commanded Timing (deg)", "Actual Physical Timing (deg)", "Mod Torque Mult", "Mod VE Mult", "Knock Chance (%)", "Opt VVT Int (deg)", "Opt VVT Exh (deg)", "Actual MAP kPa (lagged)", "Effective MAP kPa (prediction)", "SC Exponent", "SC Choke (%)", "Total Stress", "Raw Knock Chance (0-1)");
    }

    let csvContent = headers.join(",") + "\n";
    datalogRows.forEach(row => {
        csvContent += row.join(",") + "\n";
    });

    const dateStr = new Date().toISOString().replace(/[:.]/g, '-');
    const engineId = sampleEngine.global_specs.engine_id.replace(/\s+/g, '_');
    const defaultFileName = `AlphaX_Datalog_${engineId}_${prefix}_${dateStr}.csv`;
    const fileName = defaultFileName;
    
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.setAttribute("href", url);
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    // Clean up for the next run
    datalogRows = [];
    lastLogRpm = 0;
    logTimeAccumulator = 0;
}
